import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Observable, Subject } from 'rxjs';
// import { Constants } from '../constants';
import { UsersService } from './users.service';

@Injectable({
  providedIn: 'root'
})
export class ExportStateService {
  private guidStateSource = new BehaviorSubject<string>('');
  guidState = this.guidStateSource.asObservable();
  private roleStateSource = new BehaviorSubject<string>('');
  roleState = this.roleStateSource.asObservable();
  private userInfoSource = new BehaviorSubject<string>('');
  userInfoState = this.userInfoSource.asObservable();

  constructor(private userService: UsersService,) { }

  getGUIDState() {
    return this.guidStateSource.getValue();
  }

  setGUIDState(name: string) {
    this.guidStateSource.next(name);
  }

  getroleState() {
    return this.roleStateSource.getValue();
  }
  setroleState(role: string) {
    this.roleStateSource.next(role);
  }

  getuserInfoState() {
    return this.userInfoSource.getValue();
  }

  setuserInfoState(value: string) {
    this.userInfoSource.next(value);
  }

  async getRoles() {

    let areRolesPresent = this.getroleState();

    if (!areRolesPresent) {
      if (!this.getGUIDState())
        await new Promise(f => setTimeout(f, 2000));
      await this.getUserInfo(localStorage.getItem('toyotaGUID')).then((x) => {
        console.log(`Valid User : ${x}`)
        if (!x){
          // window.location.replace(this.constants.LIOSMainPortalURL);
        }
      })
    }

  }

  async getUserInfo(toyotaGUID:any): Promise<boolean> {
    let isValidRole = false;
    await this.userService.getUserInfoFreeze(toyotaGUID).then(
      (result) => {
        // if (result && result.length > 0) {
        //   let userInfo = result;
        //   let rolesArray:any[] = [];
        //   userInfo.forEach((e:any) => {
        //     let roleName = e.strrole + String(e.logisticspoint ? "/" + e.logisticspoint : "")
        //     if (!rolesArray.includes(roleName))
        //       rolesArray.push(roleName)
        //   });
        //   if (rolesArray && rolesArray?.includes(this.constants.LIOS_UAC_Admin) || rolesArray?.includes(this.constants.LIOS_UAC_TEMA_Ops)
        //    || rolesArray?.includes(this.constants.LIOS_UAC_LP_Filter) || rolesArray?.includes(this.constants.LIOS_UAC_TaskManagerAdmin)
        //     || rolesArray?.includes(this.constants.LIOS_UAC_TaskManagerUser)) {
        //     isValidRole = true;
        //   }
        //   this.setroleState(JSON.stringify(rolesArray));
        //   this.setuserInfoState(JSON.stringify(userInfo[0]));
        // }
        console.log(result)
      }, error => {
        console.log(error)
      });
    return isValidRole;
  }
}

